export enum QuestionTypeShortNameEnum {
  'Picture' = 'Pic.',
  'Two Column' = '2 Clm',
  'Puz-Matching' = 'Match',
  'Choose Ten' = 'Ch 10'
}
